<template>
<div>
    <!-- 手机或者平板页面 -->
    <div v-if="deviceType=='ios'||deviceType=='android'||deviceType=='tablet'">
        <phone-share :video="video" :data="data" :user="user" :success="success" :recommends="recommends" :msg="msg" :deviceType="deviceType"></phone-share>
    </div>

    <!-- 电脑页面 -->
    <div v-else-if="deviceType=='pc'">
       <pc-share :video="video" :data="data" :user="user" :success="success" :recommends="recommends" :msg="msg"></pc-share>
    </div>

    <div v-else>
        <el-empty description="当前设备不支持查看该网页"></el-empty>
    </div>
   
</div>

</template>

<script>
import { getRecommend, getShareDetail } from '../components/network/share';
import PcShare from '../components/common/share/PcShare.vue'
import PhoneShare from '../components/common/share/PhoneShare.vue';

export default {
    name:'Share',
    components:{  PcShare, PhoneShare },
    data(){
        return {
            success:false,
            msg:'暂时无法找到，请查看相关推荐',
            deviceType:'undefined',
            id:'',
            video:'',
            data:{},
            user:{},
            recommends:[]
        }
    },
    created(){
        //判断设备类型，用于渲染页面
        this.getDeviceType();

        //解析参数ID，用于获取数据
        this.id = this.$route.params.id;

        //1.获取分享数据
       this.getShareDetail(this.id);
       //2.获取推荐数据
       this.getRecommend(this.id);
    },
    methods:{
        getShareDetail(id){
            getShareDetail(id).then(res=>{
                console.log(res);
                this.success = res.success;
                if (res.success==true) {
                    this.data = res.data;
                    this.user = res.data.user;
                    this.video = this.data.contentMedias[0].mediaUrl; 
                }else{
                    this.msg = res.msg;
                }
            })
        },
        getRecommend(id){
            getRecommend(id).then(res=>{
                console.log(res);
                this.recommends = res.data;
            })
        },
        getDeviceType(){
            var os = function () {
			var ua = navigator.userAgent,
				isWindowsPhone = /(?:Windows Phone)/.test(ua),
				isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
				isAndroid = /(?:Android)/.test(ua),
				isFireFox = /(?:Firefox)/.test(ua),
				isChrome = /(?:Chrome|CriOS)/.test(ua),
				isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox &&
					/(?:Tablet)/.test(ua)),
				isPhone = /(?:iPhone)/.test(ua) && !isTablet,
				isPc = !isPhone && !isAndroid && !isSymbian;
			return {
				isTablet: isTablet,
				isPhone: isPhone,
				isAndroid: isAndroid,
				isPc: isPc
			};
		}();
		if (os.isAndroid ) {
            this.deviceType = 'android' 
 
		} else if (os.isAndroid || os.isPhone) {
            this.deviceType = 'ios' 
 
		} else if (os.isTablet) {
			this.deviceType = 'tablet'
		} else if (os.isPc) {
			this.deviceType = 'pc'
        }
        }
    }
}
</script>

<style>
.navbar{
    display: flex;
    margin: 3%;
    align-items: center;

}
.appbtn{
    z-index: 0;
    position: fixed;
    bottom: 5%;
    left: 20%;
    width: 60%;
}

.txid{
    color: #939393;
    text-align:left;
}

.user{
    display: flex;
    justify-content: flex-start;
}

</style>


// WEBPACK FOOTER //
// src/views/Share.vue